import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zh from './zh.json';

function readSavedLang(): string {
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('fyd-lang') || 'en';
    }
  } catch {
    // jsdom + Node 22+ raise SecurityError without --localstorage-file flag.
  }
  return 'en';
}

const saved = readSavedLang();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
  },
  lng: saved,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('fyd-lang', lng);
    document.documentElement.lang = lng === 'zh' ? 'zh-CN' : 'en';
  } catch {
    /* localStorage may be unavailable in tests; silent. */
  }
});

try {
  document.documentElement.lang = saved === 'zh' ? 'zh-CN' : 'en';
} catch {
  /* document may be unavailable in non-DOM env. */
}

export default i18n;
